import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Surface the error for debugging instead of silently white-screening.
    console.error("App render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#FBF9F5] text-center px-6">
          <div className="w-14 h-14 rounded-2xl bg-[#C85A32]/15 flex items-center justify-center mb-5">
            <span className="text-2xl">🍲</span>
          </div>
          <h1 className="font-serif text-3xl text-[#2C221E]">Something slipped in the kitchen</h1>
          <p className="text-[#6E6259] mt-3 max-w-md">
            A hiccup stopped the page from loading. Reloading usually fixes it — your data is safe.
          </p>
          <button
            data-testid="error-reload-btn"
            onClick={() => { window.location.href = "/"; }}
            className="mt-7 rounded-full bg-[#C85A32] hover:bg-[#B04B26] text-white h-12 px-7 transition-colors"
          >
            Reload NourishCraft
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
